export default __webpack_public_path__ + "static/media/action-colored.16ec62b9.svg";